// New Age Combat: one-tap add-on in the cart drawer (markup in snippets/nac-cart-addon.liquid)
import { CartAddEvent } from '@theme/events';

if (!window.__nacCartAddon) {
  window.__nacCartAddon = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-nac-cart-addon-add]');
    if (!btn) return;
    e.preventDefault();
    const wrap = btn.closest('[data-nac-cart-addon]');
    const id = Number(wrap.querySelector('[data-nac-cart-addon-variant]').value);
    btn.disabled = true;
    const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sections.join(',') }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Could not add');
      btn.dispatchEvent(new CartAddEvent({}, String(id), { source: 'nac-cart-addon', itemCount: 1, sections: data.sections }));
    } catch (error) {
      btn.disabled = false;
      console.error(error);
    }
  });
}
